// extracted by mini-css-extract-plugin
export default {"grid":"GridSpacer_grid__fcirU"};